import * as React from 'react';

const SvgChevronUpDownOutline = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.582 10.443 12 4.833l-5.585 5.58L5 9l7-7 7 7.033-1.418 1.41ZM6.418 13 12 18.61l5.585-5.581L19 14.443l-7 7-7-7.033L6.418 13Z", fill: "currentColor" })));

export { SvgChevronUpDownOutline as default };
